import { TAB_PROFILE, TAB_PREFERENCES, TAB_ACCOUNT } from "/app/apps/webapp/src/app/routes/_authenticated/settings/account.tsx?tsr-shared=1";
const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/settings/account.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/settings/account.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getLatestWeightQuery } from '@/features/weight-tracking/lib/get-latest-weight.query';
import { getProfileQuery } from '@/features/settings/lib/get-profile.query';
import { listRemindersQuery } from '@/features/settings/lib/list-reminders.query';
import { getKeepScreenAwakePreferenceQuery } from '@/features/workouts/lib/get-keep-screen-awake-preference.query';
const accountSearchSchema = z.object({
  tab: z.enum([TAB_PROFILE, TAB_PREFERENCES, TAB_ACCOUNT]).optional().catch(undefined)
});
export const Route = createFileRoute('/_authenticated/settings/account')({
  validateSearch: accountSearchSchema,
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        settingsController: context.deps.controllers.settingsController,
        weightTrackingController: context.deps.controllers.weightTrackingController,
        workoutController: context.deps.controllers.workoutController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureQueryData(getProfileQuery(deps)), context.queryClient.ensureQueryData(listRemindersQuery(deps)), context.queryClient.ensureQueryData(getLatestWeightQuery(deps)), context.queryClient.ensureQueryData(getKeepScreenAwakePreferenceQuery(deps))]);
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});